export const RECEIVE_EMPLOYEES = 'employees/RECEIVE_EMPLOYEES';
export const ADD_EMPLOYEE = 'employees/ADD_EMPLOYEE';
export const EDIT_EMPLOYEE = 'employees/EDIT_EMPLOYEE';
export const REMOVE_EMPLOYEE = 'employee/REMOVE_EMPLOYEE';
export const ARCHIVE_EMPLOYEE = 'employees/ARCHIVE_EMPLOYEE';
export const RESTORE_EMPLOYEE = 'employees/RESTORE_EMPLOYEE';
export const UPDATE_TAGS = 'employee/UPDATE_TAGS';
export const REMOVE_EMPLOYEE_SEARCH = 'employee/REMOVE_EMPLOYEE_SEARCH';
